var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn toolbar__btn filter",class:_vm.itemClass,on:{"click":_vm.click}},[_c('transition',[(!_vm.isFilterPanelActive)?_c('span',{staticClass:"material-icons noselect"},[_vm._v("filter_alt")]):_c('span',{staticClass:"material-icons noselect"},[_vm._v("close")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }